import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["aria-labelledby", "data-focus", "data-hover"]

import { 
		clsx
	} from 'clsx'

	import {
		MenuItem
	} from '@headlessui/vue'

	import {
		getCurrentInstance,
		provide,
		ref
	} from 'vue'

	
	const __default__ = { name: 'VDropdownItem' }// name the component

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

	let classes = clsx(
		// Base styles
		'group cursor-default rounded-lg px-3.5 py-2.5 focus:outline-none sm:px-3 sm:py-1.5',
		// Text styles
		'text-left text-base/6 text-zinc-950 sm:text-sm/6 dark:text-white forced-colors:text-[CanvasText]',
		// Focus
		'data-[focus]:bg-yellow-500 data-[focus]:text-yellow-950',
		// Hover
		'data-[hover]:bg-yellow-500 data-[hover]:text-yellow-950',
		// Disabled state
		'data-[disabled]:opacity-50',
		// Forced colors mode
		'forced-color-adjust-none forced-colors:data-[focus]:bg-[Highlight] forced-colors:data-[focus]:text-[HighlightText] forced-colors:[&>[data-slot=icon]]:data-[focus]:text-[HighlightText]',
		// Use subgrid when available but fallback to an explicit grid layout if not
		'col-span-full grid grid-cols-[auto_1fr_1.5rem_0.5rem_auto] items-center supports-[grid-template-columns:subgrid]:grid-cols-subgrid',
		// Icons
		'[&>[data-slot=icon]]:col-start-1 [&>[data-slot=icon]]:row-start-1 [&>[data-slot=icon]]:-ml-0.5 [&>[data-slot=icon]]:mr-2.5 [&>[data-slot=icon]]:size-5 sm:[&>[data-slot=icon]]:mr-2 [&>[data-slot=icon]]:sm:size-4',
		'[&>[data-slot=icon]]:text-zinc-500 [&>[data-slot=icon]]:data-[focus]:text-yellow-700 [&>[data-slot=icon]]:dark:text-zinc-400 [&>[data-slot=icon]]:data-[focus]:dark:text-white',
		// Avatar
		'[&>[data-slot=avatar]]:-ml-1 [&>[data-slot=avatar]]:mr-2.5 [&>[data-slot=avatar]]:size-6 sm:[&>[data-slot=avatar]]:mr-2 sm:[&>[data-slot=avatar]]:size-5'
	)

	const labelId = 'label-' + getCurrentInstance()?.uid
	provide('labelId', labelId)

	const focused = ref(false)
	const hovered = ref(false)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(MenuItem), null, {
    default: _withCtx(() => [
      _createElementVNode("button", {
        type: "button",
        "aria-labelledby": labelId || undefined,
        onFocusin: _cache[0] || (_cache[0] = ($event: any) => (focused.value = true)),
        onFocusout: _cache[1] || (_cache[1] = ($event: any) => (focused.value = false)),
        "data-focus": focused.value || hovered.value ? true : null,
        onMouseover: _cache[2] || (_cache[2] = ($event: any) => (hovered.value = true)),
        onMouseout: _cache[3] || (_cache[3] = ($event: any) => (hovered.value = false)),
        "data-hover": hovered.value ? true : null,
        class: _normalizeClass(_unref(classes))
      }, [
        _renderSlot(_ctx.$slots, "default")
      ], 42, _hoisted_1)
    ]),
    _: 3
  }))
}
}

})